import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import { AuthService } from '../auth/services/auth.service';
import { SingUpService } from '../shared/services/signup.service';
import { LanguageService } from '../shared/services1/language.service';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router, private signup: SingUpService, private languageService: LanguageService) {}

    canActivate(route: ActivatedRouteSnapshot) {

        const currentUser = this.authService.currentUserValue;
        if (currentUser.termsAccepted === false) {
            const signInUrl = this.languageService.getLanguageAwareUrl('/sign-in?terms=true');
            this.router.navigateByUrl(signInUrl);
            return ;
            
        }
        if (currentUser?.userType) {
            if(route.data && route.data.allowedRoles){
                if(route.data.allowedRoles.includes(currentUser.userType)){
                    return true;
                }
                else{
                    if(currentUser.userType === 2 || currentUser.userType ===3){
                        const sellerDashUrl = this.languageService.getLanguageAwareUrl('dashboard/seller/dashboard');
                        this.router.navigateByUrl(sellerDashUrl);
                        return true;
                    }
                    if(currentUser.userType === 4 || currentUser.userType ===5){
                        const buyerDashUrl = this.languageService.getLanguageAwareUrl('dashboard/buyer/dashboard');
                        this.router.navigateByUrl(buyerDashUrl);
                        return true;
                    }
                }
            }
            return true;
        }else{   
            const homeUrl = this.languageService.getLanguageAwareUrl('/home');
            this.router.navigateByUrl(homeUrl);
            return false;
        }
    }
}